(function (global, doc) {
  'use strict';
  if (global.ArtworkCartDawn) return;
  var pending = false, rerun = false, timer;
  function draw(map, cfg) {
    doc.querySelectorAll('cart-items [data-artwork-key], cart-drawer [data-artwork-key]').forEach(function (row) {
      var art = map[row.dataset.artworkKey];
      row.querySelectorAll('.product-option dt').forEach(function (dt) {
        if (!/^Artwork [Ff]ile:$/.test(dt.textContent.trim())) return;
        var dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        var url = art && global.ArtworkCart.thumbnail(art.url,cfg);
        if (url && dd.dataset.artworkTried === url) return;
        dd.querySelectorAll('[data-artwork-thumb]').forEach(function (n) { n.remove(); });
        if (!url) { delete dd.dataset.artworkTried; return; }
        dd.dataset.artworkTried = url;
        var img = doc.createElement('img'), done = false;
        img.setAttribute('data-artwork-thumb',''); img.width = img.height = 48; img.alt = '';
        img.style.objectFit = 'contain'; img.decoding = 'async';
        function fail() { if (done) return; done = true; img.remove(); }
        img.addEventListener('error',fail);
        img.addEventListener('load',function () { if (!img.naturalWidth) fail(); else done = true; });
        img.src = url; dd.prepend(img);
        setTimeout(function () { if (!done) fail(); },12000);
      });
    });
  }
  function refresh() {
    if (pending) { rerun = true; return; }
    var cfgNode = doc.querySelector('[data-artwork-config]');
    if (!cfgNode || !global.ArtworkCart) return;
    var cfg = JSON.parse(cfgNode.textContent); pending = true;
    var root = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'})
      .then(function (r) { if (!r.ok) throw new Error('cart unavailable'); return r.json(); })
      .then(function (j) { if (!rerun) draw(global.ArtworkCart.cartMap(j),cfg); })
      .catch(function () {}).finally(function () { pending = false; if (rerun) { rerun=false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer=setTimeout(refresh,100); }
  function start() {
    schedule();
    new MutationObserver(function (records) {
      if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
        return n.nodeType===1 && (n.matches('[data-artwork-key]') || n.querySelector('[data-artwork-key]'));
      }); })) schedule();
    }).observe(doc.body,{subtree:true,childList:true});
    doc.addEventListener('cart:updated',schedule);
  }
  global.ArtworkCartDawn={refresh:refresh};
  if(doc.readyState==='loading') doc.addEventListener('DOMContentLoaded',start); else start();
}(window,document));
